import { render, staticRenderFns } from "./AlarmDetectorDetail.vue?vue&type=template&id=754ba734&scoped=true"
import script from "./AlarmDetectorDetail.vue?vue&type=script&lang=js"
export * from "./AlarmDetectorDetail.vue?vue&type=script&lang=js"
import style0 from "./AlarmDetectorDetail.vue?vue&type=style&index=0&id=754ba734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754ba734",
  null
  
)

export default component.exports